<template>
  <iframe :style="style" :id="id" :width="width" :height="height">
  </iframe>
</template>

<script>
export default {
  name: "SiteSearchFrame",
  props: {
    config: {
      type: Object,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    debugBorder: {
      type: Boolean,
      default: false
    },
    demo: {
      type: String,
      default: "NONE"
    },
    demoQuery: {
      type: String,
      default: "Curry"
    },
    isVisible: Boolean,
    isMobile: {
      type: Boolean,
      default: false
    },
    paddingTop: {
      type: Number,
      default: 0
    },
    contentImg: String,
    headerImg: String,
    cursorImg: String
  },
  computed: {
    style() {
      return {
        border: "none"
      };
    }
  },
  data() {
    return {
      id: this.generateId(),
      timeOutId: -1,
      inputField: undefined,
      contentDocument: undefined,
      contentWindow: undefined
    };
  },
  methods: {
    bindTrackingEvent(){
      var callback = function(el){
        el.removeEventListener("click", this.dispatchTrackingEvent);
        el.removeEventListener("focus", this.dispatchTrackingEvent);
      
        if(!this.hasBeenTracked){
          el.addEventListener("click", this.dispatchTrackingEvent);
          el.addEventListener("focus", this.dispatchTrackingEvent);
        }
      }.bind(this);
      this.contentDocument.querySelectorAll("a, button").forEach(callback);
      this.contentDocument.querySelectorAll("input").forEach(callback);
    },
    dispatchTrackingEvent(e){
      if(!e.isDemoEvent){
        this.triggerEvent(window, "playground-interacted");
        this.bindTrackingEvent();
      }
    },
    showDemo(){
      if(this.demo==="NONE"){
        return;
      }
      setTimeout(function(){
        setTimeout(this.bindTrackingEvent.bind(this), 1500);
        if(this.demo==="SUGGEST"){
          this.showSuggestDemo();
          return;
        }
        if(this.demo==="SERP"){
          this.showSerpDemo();
        }
      }.bind(this), 1000);
    },
    triggerEvent(target, eventName, data){
        if(!target){
          return;
        }
        var e = undefined;
        if (window.CustomEvent) {
          try{
            e = new CustomEvent(eventName);
          }catch(ex){
          }
        } 
        if(e===undefined) {
          e = this.contentDocument.createEvent('CustomEvent');
          e.initCustomEvent(eventName, true, true, {});
        }
        if(data){
          Object.keys(data).forEach(function(key){
            e[key] = data[key];
          });
          // for(let key of Object.keys(data)){
          //   e[key] = data[key];
          // }
        }
        e['isDemoEvent'] = true;
        target.dispatchEvent(e);
    },
    showSuggestDemo(){
      if(!this.inputField){
        return;
      }
      this.inputField.value = this.demoQuery;
      if('SS360' in this.contentWindow){
        const focusedElement = document.activeElement;
        this.triggerEvent(this.inputField, "focus");
        if(focusedElement){
          this.triggerEvent(focusedElement, "focus");
        }
        this.triggerEvent(this.inputField, "keydown", {keyCode: 65});
        setTimeout(function(){
          this.triggerEvent(this.inputField, "keydown", {keyCode: 40})
        }.bind(this), 500);
      }else{
        setTimeout(this.showSuggestDemo.bind(this), 500);
      }
    },
    showSerpDemo(){
      if(this.inputField){
        this.inputField.value = this.demoQuery;
      }
      if('SS360' in this.contentWindow){
          let timeoutDuration = 0;
          if(this.config.results === undefined || this.config.results.fullScreenConfig!==undefined){
            timeoutDuration = this.config.style.animationSpeed || 250;
            this.triggerEvent(this.contentDocument.getElementById("ss360-trigger"), "click");
          }
          setTimeout(function(){
            if(this.contentDocument.getElementById("ss360-query")){          
              this.contentDocument.getElementById("ss360-query").value = this.demoQuery;
            }
            this.contentWindow.SS360.showResults(this.demoQuery);
          }.bind(this), timeoutDuration);
      }else{
        setTimeout(this.showSerpDemo.bind(this), 500);
      }
    },
    generateId() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return (
        s4() +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        s4() +
        s4()
      );
    },
    preventRedirect(e){
    },
    setInnerHtml() {
      this.contentWindow = document.getElementById(this.id).contentWindow;
      if('NodeList' in this.contentWindow && !this.contentWindow.NodeList.prototype.forEach){
        this.contentWindow.NodeList.prototype.forEach = function (callback, thisArg) {
          thisArg = thisArg || window;
          for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
          }
        };
      }

      this.contentDocument = this.contentWindow.document;
      const contentDocument = this.contentDocument;

      //apply styles
      const head = contentDocument.getElementsByTagName("head")[0];
      head.innerHTML = "";
      const fontLink = contentDocument.createElement("link");
      fontLink.rel = "stylesheet";
      fontLink.href = "https://fonts.googleapis.com/css?family=Open+Sans";
      head.appendChild(fontLink);
      const fontStyle = contentDocument.createElement("style");
      fontStyle.innerText = "*{font-family: 'Open Sans', sans-serif;}";
      head.appendChild(fontStyle);

      //build dom
      const body = contentDocument.getElementsByTagName("body")[0];
      body.innerHTML = "";
      // body.style.paddingTop = "2em";
      body.style.overflow = "hidden";
      if(!this.isMobile){
        body.style.background = "#fff";
      }
      if(this.headerImg!==undefined){
        const headerImage = contentDocument.createElement("img");
        headerImage.style.width = "100%";
        headerImage.style.position = "fixed";
        headerImage.style.zIndex = "999999999";
        headerImage.style.top = "0";
        headerImage.style.left = "0";
        headerImage.src = this.headerImg;
        body.appendChild(headerImage);
      }

      const outterWrapper = contentDocument.createElement("div");
      outterWrapper.style.display = "block";
      outterWrapper.style.width = "100%";
      outterWrapper.style.marginTop = "1em";
      const inputWrapper = contentDocument.createElement("div");
      inputWrapper.style.display = "flex";
      inputWrapper.style.justifyContent = "center";
      inputWrapper.style.width = "100%";
      if (this.config.results === undefined || this.config.results.fullScreenConfig === undefined) {
        const input = contentDocument.createElement("input");
        input.type = "text";
        input.id = "searchBox";
        if(this.config.searchBox === undefined || this.config.searchBox.placeholder === undefined || this.config.searchBox.placeholder.length === 0){
            input.placeholder = "Search any recipe";
        }
        inputWrapper.appendChild(input);
        this.inputField = input;
        if (
          this.config.searchBox !== undefined &&
          this.config.searchBox.searchButton !== undefined
        ) {
          const searchButton = contentDocument.createElement("input");
          searchButton.type = "submit";
          searchButton.id = "ss360SearchButton";
          inputWrapper.appendChild(searchButton);
        }
      } else {
        const trigger = contentDocument.createElement("button");
        trigger.innerText = "Click To Search";
        trigger.id = "ss360-trigger";
        inputWrapper.appendChild(trigger);
        const triggerStyle = contentDocument.createElement("style");
        triggerStyle.innerText = "#ss360-trigger{border:2px solid #1c5d7d;background:#fff;color:#1c5d7d;padding:1em 2em;font-weight:700}#ss360-trigger:hover{background:#1c5d7d;color:#fff;cursor:pointer}";
        body.appendChild(triggerStyle);
      }
      outterWrapper.appendChild(inputWrapper)
      body.appendChild(outterWrapper);

      // append target block
      const target = contentDocument.createElement("div");
      const contentImage = contentDocument.createElement("img");
      target.id = "ss360-target";
      target.style.margin = "2em";
      target.style.height = "calc(100% - 3.5em)";
      contentImage.src = this.contentImg;
      contentImage.style.width = "100%";
      target.appendChild(contentImage);
      body.appendChild(target);
      
      const configScript = contentDocument.createElement("script");
      configScript.type = "text/javascript";

      // turn off data points
      const configCopy = JSON.parse(JSON.stringify(this.config)); 
      configCopy['siteId'] = 'spoonacular.com';
      if(configCopy['layout']===undefined){
        configCopy['layout'] = {};
      }
      if(configCopy['layout']['mobile']===undefined){
        configCopy.layout.mobile = {};
      }
      if(configCopy['layout']['desktop']===undefined){
        configCopy.layout.desktop = {};
      }
      configCopy.layout.mobile.showDataPoints = false;
      configCopy.layout.desktop.showDataPoints = false;
      configCopy.tracking = {};
      configCopy.tracking.enhanced = false;
      if(configCopy.results.moreResultsButton===undefined){
        configCopy.results.moreResultsButton = null;
      }
      if(configCopy.results !== undefined && configCopy.results.embedConfig!==undefined){
        configCopy.results.embedConfig.contentBlock = "#ss360-target";
        configCopy.results.embedConfig.url = undefined;
      }
      if(configCopy.results!==undefined && configCopy.results.fullScreenConfig!==undefined){
        configCopy.results.fullScreenConfig.trigger = "#ss360-trigger";
	  }
	  if(configCopy.results === undefined) {
		  configCopy.results = {};
	  }

	  configCopy.results.focusResultBlock = false;

      if(configCopy.searchBox !== undefined && configCopy.searchBox.selector !== undefined){
        configCopy.searchBox.selector = "#searchBox";
      }
      if(configCopy.searchBox !== undefined && configCopy.searchBox.searchButton !== undefined){
        configCopy.searchBox.searchButton = "#ss360SearchButton";
      }
      
      // prevent redirects
      configCopy.results.linksOpenNewTab = true;

      // create config
      configScript.innerHTML =
        "window.ss360Config = " + JSON.stringify(configCopy) + ";"+ 
        "window.ss360Config.callbacks = {enterResult: function(txt, href){window.open(href,'_blank');}}"; //prevent suggest redirects

      
      // run it
      body.appendChild(configScript);
      const searchScript = contentDocument.createElement("script");
      searchScript.type = "text/javascript";
      searchScript.src = "https://cdn.sitesearch360.com/v13/sitesearch360-v13.min.js";
      body.appendChild(searchScript);

      
      // change scrollbar style
      if(this.isMobile){
          const scrollBarStyle = contentDocument.createElement("style");
          scrollBarStyle.innerText = "::-webkit-scrollbar{width:10px}::-webkit-scrollbar-track{background:#f1f1f1}::-webkit-scrollbar-thumb{background:#888}::-webkit-scrollbar-thumb:hover{background:#555}";
          body.appendChild(scrollBarStyle);
      }

      // fix jumping content when mobile layer is fading in
      if(this.isMobile){
        const hiddenStyle = contentDocument.createElement("style");
        hiddenStyle.innerText = "#unibox-special-hidden-content{overflow:initial!important}";
        body.appendChild(hiddenStyle);
      }

      // make overflow work in case of embed
      this.updatePadding();

      if(this.cursorImg){
        const cursorStyle = contentDocument.createElement("style");
        cursorStyle.innerText = "body *{cursor:url("+this.cursorImg+"),auto!important}";
        body.appendChild(cursorStyle);
      }

      this.bindTrackingEvent();

      // update demo
      this.showDemo();

    },
    updatePadding(){
        this.contentDocument.getElementsByTagName("html")[0].style.paddingTop = this.paddingTop + "px";
        const current = this.contentDocument.getElementById("ss360-overflow-style");
        if(current!==null){
          current.parentNode.removeChild(current);
        }
        const overflowStyle = this.contentDocument.createElement("style");
        overflowStyle.setAttribute("id", "ss360-overflow-style");
		overflowStyle.innerText = `#ss360-target #ss360-layer{
				overflow:auto;
				max-height:calc(100% - 2em);
			}
			#ss360-search-console.ss360-fullscreen-layer--open{
				margin-top: ${(this.paddingTop+(this.isMobile?1:0))}px;
				height:calc(100% - ${this.paddingTop}px)
			}
			#ss360-search-console.ss360-fullscreen-layer--open #ss360CloseLayerButton{
				top:${this.paddingTop+9}px
			}
			#unibox-special-transition-background, #unibox-special{
				margin-top:${this.paddingTop+1}px!important
			}
			body{
				overflow:hidden!important
			}
			#ss360-layer.ss360-layer--overlay{
				margin-top:${this.isMobile?this.paddingTop:25}px
			}
		`;
        this.contentDocument.querySelector("body").appendChild(overflowStyle);
    }
  },
  mounted() {
    this.setInnerHtml();
    var firefoxCheckCallback = function(){
      try{
          if(this.isMobile){
            return;
          }
          if(this.contentDocument.querySelector("body").getBoundingClientRect().height===0){ //Firefox Fix
            this.setInnerHtml();
          }
        }catch(ex){
          // in case already destroyed
        }
    }
    setTimeout(firefoxCheckCallback.bind(this), 2000);
  },
  watch: {
    paddingTop(){
      this.updatePadding();
    },
    config: {
      handler() {
        window.clearTimeout(this.timeOutId);
        this.timeOutId = setTimeout(this.setInnerHtml.bind(this), 600);
      },
      deep: true
    },
    demo(newDemo, oldDemo){
      if(oldDemo=="SUGGEST"){
        this.triggerEvent(this.inputField, "keyup", {keyCode: 27});
        this.triggerEvent(this.contentDocument.querySelector("button.unibox-special-close"), "click");
      }else if(oldDemo=="SERP"){
        if('SS360' in this.contentWindow){
          this.contentWindow.SS360.closeLayer();
        }
      }
      this.showDemo();
    },
    isVisible(newVisibility, oldVisibility){
        this.setInnerHtml(); // searchbox icon fix...
    }
  }
};
</script>

<style>
@media (max-width: 400px) {
  #searchBox {
    display: none;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/preview/SiteSearchFrame.vue